import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useRef } from "react";
import Cookies from "js-cookie";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { usePayrollContext } from "../../../Context/PayrollContext";

const PayrollAddReimbursementModel = ({ staff }) => {
  const { baseUrl, openToast } = useGlobalContext();
  const {
    isLoading,
    isOffCanvasOpenAction,
    setIsLoading,
    reimbursementData,
    fetchStaffs,
    editMode,
    setEditMode,
    setIsOffCanvasOpenAction,
    setActiveReimbursementStaff,
  } = usePayrollContext();
  const sidebarRef = useRef(null);

  const [formData, setFormData] = useState({
    date: "",
    amount: "",
    note: "",
  });

  // Initialize form data when in edit mode
  useEffect(() => {
    if (editMode && reimbursementData) {
      setFormData({
        date: reimbursementData.date.split("T")[0],
        amount: reimbursementData.amount.toString(),
        note: reimbursementData.note,
      });
    }
  }, [editMode, reimbursementData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Function to handle reimbursement post api
  const submitReimbursement = async (data) => {
    try {
      const payload = {
        staffId: staff?.staffDetails?.id || "",
        date: data.date,
        amount: parseInt(data.amount),
        note: data.note,
        salaryId: staff?.staffDetails?.SalaryDetails[0]?.id || "",
      };
      setIsLoading(true);
      const response = await fetch(
        !editMode
          ? `${baseUrl}reimbursements`
          : `${baseUrl}reimBursements/${reimbursementData?.id}`,
        {
          method: editMode ? "PUT" : "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.status === 201) {
        setIsLoading(false);
        fetchStaffs();
        handleReset();
        openToast("Reimbrusment Added successfully", "success");
      } else if (response.status === 200 && editMode) {
        openToast("Reimbrusment Edited successfully", "success");
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error submitting reimbursement:", error);
      setIsLoading(false);
      throw error;
    } finally {
      setIsLoading(false);
      handleReset();
    }
  };

  // function to delete Reimbrusement
  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${baseUrl}reimBursements/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      const result = await response.json();
      if (response.status === 200) {
        fetchStaffs();
        openToast(
          result.message || "Reimbrusement is successfully deleted",
          "success"
        );
      }
    } catch (error) {
      openToast(error.message || "error while deleting ReimBrusments", "error");
    } finally {
      fetchStaffs();
      handleReset();
    }
  };

  // submit the Reimbrusment data
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    try {
      await submitReimbursement(formData);
    } catch (error) {
      console.error("Failed to submit reimbursement:", error);
    }
  };

  // Reset the Form when Rebrusment added or edited
  const handleReset = () => {
    setFormData({
      date: "",
      amount: "",
      note: "",
    });
    setActiveReimbursementStaff(null);
    setEditMode(false);
    fetchStaffs();
    setIsOffCanvasOpenAction(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOffCanvasOpenAction(); // Close sidebar if clicked outside
      }
    }

    if (isOffCanvasOpenAction) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOffCanvasOpenAction, setIsOffCanvasOpenAction]);

  return (
    <div
      ref={sidebarRef}
      className={`fixed top-[56px] right-0 h-screen sm:w-[400px] w-full z-[99] shadow-cs bg-white payroll-sidebar shadow-lg transform transition-transform duration-300 ${
        isOffCanvasOpenAction ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="relative w-full h-full">
        <div className="flex justify-between items-center border-gray-200 p-4 border-b">
          <h2 className="font-semibold text-[#000] text-[18px]">
            {staff?.name}
          </h2>
          <button type="button" className="text-[black]" onClick={handleReset}>
            <CloseIcon />
          </button>
        </div>
        <div className="relative z-[1] bg-red mb-[10px] p-[10px] pb-[20px] w-full h-[82%] overflow-y-scroll">
          <div className="flex justify-between items-center bg-[#e5e7eb3b] mb-[10px] p-[10px] w-full">
            <p className="font-normal text-muted-foreground text-sm">
              {editMode ? "Edit Reimbursement" : "Add Reimbrusement"}
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="flex justify-between items-center pt-[14px]">
              <label htmlFor="amount" className="font-light text-[14px]">
                Amount
              </label>
              <div className="relative">
                <input
                  id="amount"
                  type="text"
                  name="amount"
                  value={formData.amount}
                  onChange={handleInputChange}
                  required
                  className="focus:shadow-cs px-[10px] py-[5px] pl-[22px] border rounded-[10px] w-[232px] focus-visible:outline-none"
                />
                <span className="top-[6px] left-[12px] absolute">₹</span>
              </div>
            </div>
            <div className="flex justify-between items-center pt-[14px]">
              <label htmlFor="date" className="font-light text-[14px]">
                Payment Date
              </label>
              <div className="">
                <input
                  id="date"
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  required
                  className="focus:shadow-cs px-[10px] py-[5px] border rounded-[10px] w-[232px] font-light focus-visible:outline-none"
                />
              </div>
            </div>
            <div className="flex justify-between items-center pt-[14px]">
              <label htmlFor="note" className="font-light text-[14px]">
                Notes
              </label>
              <div className="">
                <textarea
                  id="note"
                  name="note"
                  value={formData.note}
                  onChange={handleInputChange}
                  className="focus:shadow-cs px-[10px] py-[5px] pl-[20px] border rounded-[10px] w-[232px] font-light focus-visible:outline-none"
                />
              </div>
            </div>
            <div className="bottom-[40px] sm:bottom-[20px] left-0 absolute w-full">
              <div className="px-[20px] py-[5px] pl-[12px] sm:-pl-auto">
                <h2>Total Amount Paid - ₹ {formData.amount || "0"}</h2>
              </div>
              <div className="flex justify-between px-[20px]">
                <button
                  type="button"
                  disabled={!editMode}
                  className={`w-[48%] border-1  px-[20px] border ${
                    !editMode
                      ? "border-red-400 text-red-300"
                      : "border-red-600 text-red-600 hover:bg-red-600 hover:text-white"
                  } rounded-[10px] font-normal text-[15px]   transition-all`}
                  onClick={() => {
                    handleDelete(reimbursementData?.id);
                  }}
                >
                  Delete
                </button>
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`justify-center w-[48%]  ${
                    isLoading ? "inactive-btn cursor-not-allowed" : "second-btn"
                  }`}
                >
                  Save Payment
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PayrollAddReimbursementModel;
